/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {
  Alert, AlertTitle, Button, Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const PostponedAlert = ({ handleReactivation, isReactivating }: {
  handleReactivation: () => void;
  isReactivating: boolean;
}) => (
  <Alert
    severity="warning"
  >
    <AlertTitle>Postponed Trip</AlertTitle>
    <span>
      This trip has been marked as
      {' '}
      <em>Postponed</em>
      {' '}
      and has been moved into the corresponding category within the assignee&apos;s queue.
      This means it is not currently being processed. You may reactivate this trip and move it back into the assignee’s queue.
    </span>
    <LoadingButton
      variant="contained"
      onClick={handleReactivation}
      loading={isReactivating}
    >
      Reactivate
    </LoadingButton>
  </Alert>
);

const VerifyUserAlert = ({ handleVerify, loading }: {
  handleVerify: () => void;
  loading: boolean;
}) => (
  <Alert severity="warning">
    <AlertTitle>Unverified User</AlertTitle>
    <span>
      This trip is
      {' '}
      <em>Unverified</em>
      {' '}
      because the traveler has not verified their email.
    </span>
    <LoadingButton loading={loading} variant="contained" onClick={handleVerify}>Verify Traveler</LoadingButton>
  </Alert>
);

const OutsideReferralAlert = () => (
  <Alert severity="warning">
    <AlertTitle>Outside Referral</AlertTitle>
    This trip was not suitable for matching with our partners and has been referred outside Zicasso.
  </Alert>
);

const JunkAlert = ({ handleClick } : {
  handleClick: () => void;
}) => (
  <Alert severity="error">
    <AlertTitle>Junk Trip</AlertTitle>
    <Box>
      This trip has been categorized as Junk and does not meet the requirements for matching or screening. If needed, you can mark this trip <em>Not Junk</em> for processing.
    </Box>
    <Button variant="contained" onClick={handleClick}>Not Junk</Button>
  </Alert>
);

const DisabledTravelerAlert = ({ handleClick, isReenabling } : {
  handleClick: () => void;
  isReenabling: boolean;
}) => (
  <Alert severity="error">
    <AlertTitle>Account Disabled</AlertTitle>
    <Box>
      Please note that the traveler profile associated with this trip request has been disabled.
    </Box>
    <LoadingButton loading={isReenabling} variant="contained" onClick={handleClick}>
      Enable Account
    </LoadingButton>
  </Alert>
);

// eslint-disable-next-line import/prefer-default-export
export {
  PostponedAlert,
  VerifyUserAlert,
  OutsideReferralAlert,
  JunkAlert,
  DisabledTravelerAlert,
};
